import React from "react";

export default function LivroParametroTitulo(data) {
  return <h3 style={{ margin: 0, paddin: 0 }}>{data.titulo}</h3>;
}
